import { useOrganization } from '../organization';

/**
 * NOTE: This hook makes a request to GET /api/organizations/:id, which is a giant endpoint
 * that returns many, many things, one of them being a list of users. This replaces
 * the Redux action `extractUsersFromOrganization`.
 *
 * This is a stop-gap until we are able to build a better endpoint for fetching users.
 * Read more here: https://fossa.atlassian.net/browse/CORE-4781
 *
 * @deprecated -- See CORE-4781 for more information.
 */
export default function useUsersFromOrg(organizationId: number) {
  const { data: organization, ...rest } = useOrganization(organizationId);
  return {
    users: organization?.users ?? [],
    ...rest,
  };
}
